
export const EMAIL_REGX = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NAME_REGX = /^[A-Z.a-z'\b ]+$/;
export const PROMO_REGX = /^[A-Z._a-z'\b]+$/;
export const FIRST_WHITE_SPACE_NOT_ALLOWED_NAME_REGEX = /^[^-\s][a-z.A-Z_\s-]+$/;
export const PHONE_REGX = /^[0-9]+$/;
export const PRICE_REGX = /^[0-9]*\.?[0-9]{0,2}$/;
export const WEBSITE_REGEX = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
export const REFERENCE_REGX = /^[A-Za-z0-9\b]+$/;